// extracted by mini-css-extract-plugin
export default {"error":"NameAndDescription_error__w1vUb","disabled":"NameAndDescription_disabled__Yckqv"};